<template>
  <div>
    <list-block>
      <el-form
        ref="formData"
        :inline="true"
        :rules="rules"
        :model="formData"
      >
        <h4 style="margin-bottom: 10px;">
          节点通用设置
        </h4>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="可选货品质量："
              prop="goodsQualityList"
            >
              <el-checkbox-group
                v-model="formData.goodsQualityList"
                :disabled="isDetail"
              >
                <el-checkbox
                  v-for="checkbox in GOODS_QUALITY_OPTIONS"
                  :key="checkbox.code"
                  :label="checkbox.code"
                >
                  {{ checkbox.name }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="默认货品质量："
              prop="defaultGoodsQuality"
            >
              <el-radio-group
                v-model="formData.defaultGoodsQuality"
                :disabled="isDetail"
              >
                <el-radio
                  v-for="checkbox in DEFAULT_GOODS_QUALITY_OPTIONS"
                  :key="checkbox.code"
                  :label="checkbox.code"
                >
                  {{ checkbox.name }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="是否允许超收："
              prop="allowOvercharge"
            >
              <el-radio-group
                v-model="formData.allowOvercharge"
                :disabled="isDetail"
              >
                <el-radio
                  v-for="checkbox in BOOLEAN_STATE"
                  :key="checkbox.label"
                  :label="checkbox.value"
                >
                  {{ checkbox.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              v-if="formData.allowOvercharge === BOOLEAN_STATE[0].value"
              label="允许超收比例(%)："
              prop="overchargePercent"
            >
              <div style="display: flex;align-items: center;">
                <el-input
                  v-model="formData.overchargePercent"
                  style="margin-right: 20px;"
                  :disabled="isDetail || unlimited"
                />
                <el-checkbox
                  v-model="unlimited"
                  label="不限制"
                  @change="handleUnlimitChange"
                />
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="容器是否允许混批次："
              prop="allowContainerMixBatch"
            >
              <el-radio-group
                v-model="formData.allowContainerMixBatch"
                :disabled="isDetail"
              >
                <el-radio
                  v-for="checkbox in BOOLEAN_STATE"
                  :key="checkbox.label"
                  :label="checkbox.value"
                >
                  {{ checkbox.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="容器是否允许混货品："
              prop="allowContainerMixGoods"
            >
              <el-radio-group
                v-model="formData.allowContainerMixGoods"
                :disabled="isDetail"
              >
                <el-radio
                  v-for="checkbox in BOOLEAN_STATE"
                  :key="checkbox.label"
                  :label="checkbox.value"
                >
                  {{ checkbox.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="是否支持货品码："
              prop="enableGoodsTagCode"
            >
              <el-radio-group
                v-model="formData.enableGoodsTagCode"
                :disabled="isDetail"
              >
                <el-radio
                  v-for="checkbox in BOOLEAN_STATE"
                  :key="checkbox.label"
                  :label="checkbox.value"
                >
                  {{ checkbox.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="是否强制验证货品码："
              prop="validateGoodsTagCode"
            >
              <el-radio-group
                v-model="formData.validateGoodsTagCode"
                :disabled="isDetail"
              >
                <el-radio
                  v-for="checkbox in BOOLEAN_STATE"
                  :key="checkbox.label"
                  :label="checkbox.value"
                >
                  {{ checkbox.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="是否验证单板数量："
              prop="validateVeneerNum"
            >
              <el-radio-group
                v-model="formData.validateVeneerNum"
                :disabled="isDetail"
              >
                <el-radio
                  v-for="checkbox in BOOLEAN_STATE"
                  :key="checkbox.label"
                  :label="checkbox.value"
                >
                  {{ checkbox.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="供应商端是否允许验收："
              prop="supplierAllowAcceptance"
            >
              <el-radio-group
                v-model="formData.supplierAllowAcceptance"
                :disabled="isDetail"
              >
                <el-radio
                  v-for="checkbox in BOOLEAN_STATE"
                  :key="checkbox.label"
                  :label="checkbox.value"
                >
                  {{ checkbox.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="是否验证新品："
              prop="isValidatorNewProduct"
            >
              <el-radio-group
                v-model="formData.isValidatorNewProduct"
                :disabled="isDetail"
              >
                <el-radio
                  v-for="checkbox in BOOLEAN_STATE"
                  :key="checkbox.label"
                  :label="checkbox.value"
                >
                  {{ checkbox.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="PDA验收是否可跳过容器："
              prop="isSkipContainer"
            >
              <el-radio-group
                v-model="formData.isSkipContainer"
                :disabled="isDetail"
              >
                <el-radio
                  v-for="checkbox in BOOLEAN_STATE"
                  :key="checkbox.label"
                  :label="checkbox.value"
                >
                  {{ checkbox.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="入库暂存位:">
              <el-row v-for="list in TEMPORARY_STOREHOUSE" :key="list.value">
                <el-form-item
                  :label="list.label"
                  :prop="`temporaryStorehouse.${list.code}`"
                  :rules="[{ required: true, message: '请选择', trigger: 'change' }]"
                >
                  <el-select
                    v-model="formData.temporaryStorehouse[list.code]"
                    placeholder="请选择"
                    filterable
                    :disabled="isDetail || warehouseFoundationObj[list.temporary].disabled"
                    @change="(code) => handleAcceptStorehouseChange(code, list)"
                  >
                    <el-option
                      v-for="item in warehouseFoundationObj[list.temporary].option"
                      :key="item.locationId"
                      :label="item.locationCode"
                      :value="item.locationCode"
                    />
                  </el-select>
                </el-form-item>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
        <TaskSetting
          ref="taskTableEl"
          :node-index="3"
          :table-data="formData.taskItemDetails"
        />
      </el-form>
    </list-block>
  </div>
</template>

<script>
import ListBlock from '@/components/ListBlock/index.vue';
import { getDictionary } from '@/utils/Dictionary';
import { tempStoreHouse } from '@/api/configure/warehousingProcess';
import TaskSetting from './TaskSetting.vue';
import {
  BOOLEAN_STATE,
  TEMPORARY_STOREHOUSE,
  NODE_TYPE,
} from './constant';

export default {
  components: {
    ListBlock,
    TaskSetting,
  },
  props: {
    formData: {
      type: Object,
      default: () => {},
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
    warehouseCode: {
      type: String,
      default: '',
    },
    warehouseId: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    const validateOverchargeRatio = (rule, value, callback) => {
      const reg = /^(?:0\.\d{1,2}|[1-9]\d{0,2}(?:\.\d{1,2})?|1000)$/;
      if (!reg.test(value) && value !== null) {
        callback(new Error('请输入大于0，小于1000的数字，支持2位小数。'));
      } else {
        callback();
      }
    };
    return {
      BOOLEAN_STATE,
      TEMPORARY_STOREHOUSE,
      GOODS_QUALITY_OPTIONS: [],
      warehouseFoundationObj: {
        NORMAL: {
          disabled: false,
          option: [],
        },
        REFRIGERATE: {
          disabled: false,
          option: [],
        },
        COLD: {
          disabled: false,
          option: [],
        },
        CONSTANT: {
          disabled: false,
          option: [],
        },
      },
      unlimited: true,
      rules: {
        goodsQualityList: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        defaultGoodsQuality: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        allowOvercharge: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        overchargePercent: [
          {
            required: true,
            validator: validateOverchargeRatio,
            trigger: ['blur', 'change'],
          },
        ],
        allowContainerMixBatch: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        allowContainerMixGoods: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        enableGoodsTagCode: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        validateGoodsTagCode: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        validateVeneerNum: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        supplierAllowAcceptance: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        isValidatorNewProduct: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        isSkipContainer: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        location: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
      },
    };
  },
  computed: {
    DEFAULT_GOODS_QUALITY_OPTIONS() {
      const list = this.GOODS_QUALITY_OPTIONS.filter((item) => this.formData.goodsQualityList.includes(item.code));
      if (this.formData.goodsQualityList.indexOf(this.formData.defaultGoodsQuality) < 0) {
        this.$emit('resetDefaultQa');
      }
      return [...list];
    },
  },
  watch: {
    warehouseId: {
      immediate: true,
      handler(newVal, oldVal) {
        if (oldVal) {
          TEMPORARY_STOREHOUSE.forEach((item) => {
            this.formData.temporaryStorehouse[item.value] = null;
            this.formData.temporaryStorehouse[item.code] = null;
          });
        }
        if (newVal) {
          this.TEMPORARY_STOREHOUSE.forEach((item) => {
            this.warehouseFoundationObj[item.temporary] = {
              disabled: true,
              option: [],
            };
          });
          this.getStoreHouse();
        }
      },
    },
  },
  mounted() {
    const goodsQualityList = getDictionary(this.$store.state.dictionary.dictionaryCodeEN.GOODS_QUALITY);
    this.GOODS_QUALITY_OPTIONS = goodsQualityList;
    if ((this.isDetail || this.$route.query.num) && this.formData.overchargePercent === null) {
      this.unlimited = true;
    }
  },
  methods: {
    handleUnlimitChange(val) {
      if (val) {
        this.$emit('resetOverchargePercent', null);
        this.$nextTick(() => {
          this.$refs.formData.clearValidate('overchargePercent');
        });
      } else {
        this.$emit('resetOverchargePercent', 0);
      }
    },
    handleAcceptStorehouseChange(code, temporaryItem) {
      const chooseItem = this.warehouseFoundationObj[temporaryItem.temporary].option.find((item) => item.locationCode === code);
      this.formData.temporaryStorehouse[temporaryItem.value] = chooseItem.locationId;
    },
    async getStoreHouse() {
      const res = await tempStoreHouse({
        warehouseId: this.warehouseId,
        typeCode: 'VIRTUAL_GOODS_AREA',
      });
      this.warehouseFoundationObj = TEMPORARY_STOREHOUSE.reduce((prev, curr) => {
        const filterItems = res
          .filter((item) => item.temperatureLayerCode === curr.temporary);
        if (!this.formData.temporaryStorehouse[curr.value]) {
          const defaultVal = filterItems.find((item) => item.isDefault);
          if (defaultVal) {
            this.formData.temporaryStorehouse[curr.value] = defaultVal.locationId;
            this.formData.temporaryStorehouse[curr.code] = defaultVal.locationCode;
          }
        }

        return {
          ...prev,
          [curr.temporary]: {
            option: filterItems,
            disabled: false,
          },
        };
      }, {});
    },
    // 纯获取数据
    getPureTableData() {
      return this.$refs.taskTableEl.getPureTableData();
    },
    // 重置任务下拉数据
    resetTaskOptions() {
      return this.$refs.taskTableEl.resetTaskOptions();
    },
    validateForm() {
      /* eslint-disable-next-line */
      return new Promise(async (resolve) => {
        try {
          await this.$refs.formData.validate();
          const tableData = await this.$refs.taskTableEl.getTableData(3);
          resolve(tableData);
        } catch (error) {
          this.$message.warning(`请完善“${NODE_TYPE[3].label}”节点数据`);
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.pos-item {
  margin-right: 25px;
}
.label {
  margin-right: 8px;
}
</style>
